import CheckboxTogglerT from '@components/tailwind-components/Input/CheckboxTogglerT';
import type { TReportIssueParams } from '@conversed/rest/src/contracts/llm-usages/report-issue';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ConversationReviewReportIssueForm } from './ConversationReviewReportIssueForm';

type Props = {
  reportIssue: boolean;
  reportIssueParams: TReportIssueParams;
  // Disabled while the card is processing (translating / bulk / saving).
  disabled?: boolean;
  onReportIssueChange: (value: boolean) => void;
  onReportIssueParamsChange: (params: TReportIssueParams) => void;
};

export const ConversationReviewReportIssue: React.FC<Props> = ({
  reportIssue,
  reportIssueParams,
  disabled = false,
  onReportIssueChange,
  onReportIssueParamsChange,
}) => {
  const { t } = useTranslation();

  // Only expand the issue form when the toggle is on and the control is enabled.
  const isExpanded = reportIssue && !disabled;

  return (
    <div
      id='conversation-review-report-issue'
      className={`conversation-review-modal__report-issue ${
        isExpanded
          ? 'conversation-review-modal__report-issue--expanded'
          : 'conversation-review-modal__report-issue--collapsed'
      }${disabled ? ' conversation-review-modal__report-issue--disabled' : ''}`}>
      <div className='conversation-review-modal__report-issue-toggle-row'>
        <CheckboxTogglerT
          id='report-issue-toggle'
          colorScheme='red'
          toggleSize='xs'
          checked={reportIssue && !disabled}
          options={{ disabled }}
          onChange={(event) => onReportIssueChange(event.target.checked)}
        />
        <label
          htmlFor='report-issue-toggle'
          className='conversation-review-modal__report-issue-label'>
          {t('train-ai.fact-checking.report-issue')}
        </label>
      </div>
      <span className='conversation-review-modal__report-issue-description'>
        {t('train-ai.conversation-review.report-issue.description')}
      </span>
      {isExpanded && (
        <ConversationReviewReportIssueForm
          reportIssueParams={reportIssueParams}
          setReportIssueParams={onReportIssueParamsChange}
        />
      )}
    </div>
  );
};
